module.exports = __webpack_public_path__ + "Our-Working-Week-2.588ad96c891532c4872f.png";


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/assets/images/Our-Working-Week-2.png
// module id = ../../../../../src/assets/images/Our-Working-Week-2.png
// module chunks = main